import { isProd } from '../config'

const getStorageItem = (storage, key, toJson = false) => {
  if (typeof storage === 'undefined') return undefined

  const data = storage.getItem(key)

  if (!data) return data

  if (toJson) {
    try {
      return JSON.parse(data)
    } catch (error) {
      if (!isProd) console.error(error)

      return {}
    }
  }

  return data
}

const fromSS = (key, toJson = false) => {
  return getStorageItem(sessionStorage, key, toJson)
}

const fromLS = (key, toJson = false) => {
  return getStorageItem(localStorage, key, toJson)
}

export { fromSS, fromLS }
